// eslint-disable-next-line import/prefer-default-export
export const WAVE_1_SUPPLY = 250;
export const WAVE_2_SUPPLY = 689;
